export const conditionId = (num) => {
  switch (num) {
    case '1':
      return '尚未招募'
    case '2':
      return '招募中'
    case '3':
      return '招募完成'
    case '4':
      return '已完成'
    case '5':
      return '主动暂停'
    case '6':
      return '被叫停'
    default:
      return '其他'
  }
}



// WEBPACK FOOTER //
// ./src/filters/condition_id.js